const icon = require('vue-svgicon');
icon.register({
    'lens-feature-ultra-thin': {
        width: 40,
        height: 40,
        viewBox: '0 0 40 40',
        data: `<ellipse pid="0" cx="20" cy="20" rx="13" ry="8" _stroke="#000"/><path pid="1" d="M22 9c3-1 5.479-.521 7.154 1.153 3.398 3.4 1.676 10.632-3.847 16.154-5.522 5.523-12.755 7.245-16.154 3.847-.998-.999-1.554-2.328-1.702-3.847" _stroke="#000"/><path pid="2" d="M24 7l-2 2 2.5 1" _stroke="#000"/>`,
    },
});
